module.exports = __webpack_public_path__ + "static/img/restart-fr.96746ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/bottom-vr/img/restart-fr.png
// module id = Zr3H
// module chunks = 1